module.exports = __webpack_public_path__ + "img/pr-6.2300b8db.png";